import React from 'react';

/**
 * Displays the footer of the Recommended Products panel.
 *
 * @param props.addNewRequisition The function to call when the generic "Select Another Test" button is clicked
 */
const Footer = ({ addNewRequisition }) => {
	return (
		<>
			<div>
				<div style={{ borderTop: '1px solid #aaa', margin: '15px 0' }}></div>
			</div>
			<div>
				<span>
					Looking for a different product? Add it to the order now or{' '}
					<a
						href={`${process.env.REACT_APP_GDX_WEB_URL}/mygdx/consultation`}
						target="_blank"
						rel="noopener noreferrer"
					>
						schedule a consult
					</a>{' '}
					to discuss options.
				</span>
			</div>
			<div>
				<button
					onClick={addNewRequisition}
					type="button"
					className="btn btn-sm"
					style={{
						textTransform: 'none',
						backgroundColor: '#27a973',
						borderColor: '#759a75',
						color: '#fff'
					}}
				>
					Select Another Test
				</button>
			</div>
		</>
	);
};

export default Footer;
